import type { IntlShape } from 'react-intl';

import {
  buildPageStarterPrompts,
  resolvePromptPage,
} from '@/shared/agent-prompt-suggestions';
import type { AgentCorePageContext } from '@/shared/api/agentCore/agentCoreApi';

/**
 * Starter presets for the welcome grid, selected by the page the chat is
 * mounted on. Without page context (legacy call sites, tests) the patient
 * profile preset set is used.
 */
export const buildStarterPrompts = (
  formatMessage: IntlShape['formatMessage'],
  pageContext?: Pick<AgentCorePageContext, 'page' | 'path'>,
) => buildPageStarterPrompts(formatMessage, resolvePromptPage(pageContext));
